export function formatTVL(tvl: number | undefined): string {
  if (!tvl) return '$0'
  if (tvl >= 1_000_000_000) return `$${(tvl / 1_000_000_000).toFixed(2)}B`
  if (tvl >= 1_000_000) return `$${(tvl / 1_000_000).toFixed(2)}M`
  if (tvl >= 1_000) return `$${(tvl / 1_000).toFixed(2)}K`
  return `$${tvl.toFixed(2)}`
}
